export default "__VITE_ASSET__D4jNm1u2__"